import { render, staticRenderFns } from "./CloseCustomerIssue.vue?vue&type=template&id=4f7a6f8e"
import script from "./CloseCustomerIssue.vue?vue&type=script&lang=js"
export * from "./CloseCustomerIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports